var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 20,
    viewBox: "0 0 27 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1726_2474)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.13638 19.9016V9.65187L2.90113 6.74379L0 5.13V18.0928C0 19.0936 0.825293 19.9016 1.84096 19.9016H6.13638Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8635 19.9015H25.159C26.1777 19.9015 26.9999 19.0905 26.9999 18.0927V5.13L23.7139 6.9784L20.8635 9.65177V19.9015Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.13627 9.65177L5.69604 5.6469L6.13627 1.81384L13.4999 7.24016L20.8635 1.81384L21.3559 5.43996L20.8635 9.65177L13.4999 15.0781L6.13627 9.65177Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8635 1.81385V9.65178L26.9999 5.12992V2.71821C26.9999 0.481419 24.4012 -0.793711 22.5818 0.54774L20.8635 1.81385Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 5.12996L2.82224 7.20976L6.13638 9.65183V1.8139L4.41809 0.547787C2.59559 -0.793767 0 0.481466 0 2.71815V5.12996Z",
    fill: "#C5221F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1726_2474"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.f9d0c27e72117f46264181f6d116da8d.svg";
export { ForwardRef as ReactComponent };